import { useDataTrackingPush } from '../services';
import { checkFallbackFn } from '../utils';
export var useAnalyticsEventPush = function (config, logger) { return function (params) {
    var fallback = params.fallback, event = params.event, args = params.args, _a = params.type, type = _a === void 0 ? 'FIREBASE' : _a;
    if (config.isMiniApp) {
        useDataTrackingPush({ event: event, params: args, type: type }, logger);
    }
    else {
        if (checkFallbackFn(fallback)) {
            fallback({ event: event, params: args, type: type });
        }
    }
}; };
